import { Button, Drawer, Space } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import NoResults from "../../../components/shared/NoResults";
import formatMoney from "../../../utils/formatMoney";
import historyTotals from "../../../utils/historyTotals";
import { timeLap } from "../../../utils/timeLap";
import { REACT_APP_ARPS_BASE_URL } from "../../../utils/urls";

export default function Services({
  isVisible,
  setShowServices,
  selected,
  startDate,
  endDate,
}: any) {
  const [revenues, setRevenues] = useState<any>([]);
  const [history, setHistory] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  let start = moment(new Date(startDate)).format("YYYYMMDD");
  let end = moment(new Date(selected?.timeout)).format("YYYYMMDD");

  if (selected?.timeout === null) {
    start = moment(new Date(selected?.timein)).format("YYYYMMDD");
    end = moment(new Date()).format("YYYYMMDD");
  }

  const fetchRevenues = async (registration: any) => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/revenue/workshop/vehicles/${registration}?start=${start}&end=${end}`
    );
    const data = await response.json();
    setRevenues(data);
    setLoading(false);
  };

  const fetchHistory = async (registration: any) => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/service/vehicles/${registration}?start=${start}&end=${end}`
    );
    const data = await response.json();

    setHistory(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchRevenues(selected?.vehicle?.registration);
    fetchHistory(selected?.vehicle?.registration);
  }, [selected, startDate]);

  const date = history[0]?.list[0]?.service_date;
  const last = history[0]?.list[0]?.last_service_date;
  const next = history[0]?.list[0]?.next_service_date;

  if (selected === undefined) {
    return (
      <Drawer
        title={`SERVICE(S) : ${moment(startDate).format("Do MMM YYYY")}`}
        placement={"right"}
        width={500}
        onClose={() => setShowServices(!isVisible)}
        visible={isVisible}
        closable={false}
        extra={
          <Space>
            <Button
              type="default"
              color="#E50000"
              onClick={() => setShowServices(!isVisible)}
              danger
            >
              <AiOutlineClose />
            </Button>
          </Space>
        }
      >
        <div className="flex justify-center items-center font-toyota">
          No Records for {moment(startDate).format("Do MMM YYYY")}
        </div>
      </Drawer>
    );
  }

  const { invoice_value } = historyTotals(history);

  const registration = selected?.vehicle?.registration ?? "VEHICLE";

  return (
    <Drawer
      title={`${registration} SERVICE(S) : ${moment(startDate).format(
        "Do MMM YYYY"
      )}`}
      placement={"right"}
      width={500}
      onClose={() => setShowServices(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowServices(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      {history.length === 0 ? (
        <NoResults />
      ) : (
        <div className="font-toyota">
          <div className="text-2xl font-bold">
            {history[0]?.list[0]?.customer}
          </div>
          <p className="text-sm">
            <span className="font-bold">Last service date: </span>
            {!last ? (
              "-"
            ) : (
              <>{moment(last?.toString()).format("Do MMM YYYY")}</>
            )}
          </p>
          <p className="text-sm">
            <span className="font-bold">Next service date: </span>
            {!next ? (
              "-"
            ) : (
              <>{moment(next?.toString()).format("Do MMM YYYY")}</>
            )}
          </p>
          <div className="flex items-center text-sm">
            <div className="mr-2"> WIP - {history[0]?.list[0]?.wip}</div>
            <div className="">
              Time Taken : {timeLap(selected?.timein, selected?.timeout)}
            </div>
          </div>

          <div className="flex ml-6">
            <div className="flex-1">
              <div className="flex flex-col mt-2 border-b border-gray-300">
                <div className="flex justify-between">
                  <div className="flex">
                    <div className="font-bold mr-2 w-10 text-center">S/N.</div>
                    <div className="font-bold">Service Type</div>
                  </div>
                  <div className="font-bold">Amount</div>
                </div>
              </div>
            </div>
          </div>
          {history?.map((service: any, index: number) => (
            <div className="flex ml-6" key={index}>
              <div className="flex-1">
                <div className="flex flex-col mt-2">
                  {service?.list?.map((list: any, index: number) => (
                    <div
                      className="flex justify-between border-b border-gray-300"
                      key={index}
                    >
                      <div className="flex">
                        <div className="mr-2 w-10 text-center">
                          {index + 1}.
                        </div>
                        <div className="">{list?.service_details}</div>
                      </div>
                      <div className="">{formatMoney(list?.invoice_value)}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}

          <div className="ml-6">
            <div className="flex justify-between border-t-2 border-b-2 py-2">
              <div className="ml-12"></div>
              <div className="font-bold">{formatMoney(invoice_value)}</div>
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
}
